import { render, staticRenderFns } from "./Insurances.vue?vue&type=template&id=4b3a50c2&scoped=true"
import script from "./Insurances.vue?vue&type=script&lang=js"
export * from "./Insurances.vue?vue&type=script&lang=js"
import style0 from "./Insurances.vue?vue&type=style&index=0&id=4b3a50c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a50c2",
  null
  
)

export default component.exports